export default function dateFilter(value, format = 'date') {
  try {
    if (value) {
      // console.log(value)
      value = value.toString();
      const delimiter = (function() {
        const dot = value.split('.')
        const slash = value.split('/')
        if (dot.length) return '.'
        if (slash.length) return '/'
      })();
      // const iso = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      const ruDate = /^(\d{2})\.(\d{2})\.(\d{4})/;
      const ruDateShort = /^(\d{2})\.(\d{2})\.(\d{2})/;
      const unixTime = /^\d{10}$/;
      let date = null;

      if (value.match(ruDate) || value.match(ruDateShort)) {
        date = value.split(delimiter);
        date = `${date[1]}/${date[0]}/${date[2]}`
      } else if (value.match(unixTime)) {
        date = value * 1000;
      } else date = value

      // console.log(date)
      const options = {}

      if (format.includes('date')) {
        options.day = '2-digit'
        options.month = 'long'
        options.year = 'numeric'
      }
      if (format.includes('dateShort')) {
        options.day = '2-digit'
        options.month = '2-digit'
        options.year = 'numeric'
      }
      if (format.includes('time')) {
        options.hour = '2-digit'
        options.minute = '2-digit'
      }
      let str = new Intl.DateTimeFormat('ru-RU', options).format(new Date(date));

      return format === 'date'
          ? str.substr(0, str.length - 3)
          : str
    }
  } catch (e) {
    console.log(e)
  }
}
